import Wrapper from "../../Wrapper";

 const DetailedExcelReport = ()=>{
     return (
         <>
         <Wrapper>
            <h3 style={{textAlign: "center",position: "relative", top: "50px", color:"#bf2527"}}>Detailed Excel Report</h3>
         </Wrapper>
         </>
     );
 }
 export default DetailedExcelReport;